<trial-signup-page>
  <div if="{locale}" class="split-container">
    <!-- Left Panel: Branding & Trial Info -->
    <div class="start-panel bg-primary">
      <div class="brand-section">
        <div class="logo-badge">
          <img src="./OP-primary-dark.png" alt="OnPoint Digital" class="company-logo" />
        </div>
        
        <div class="trial-info">
          <h1 class="trial-title">{locale?.t('trialsignup_title')}</h1>
          <!-- Left-panel header: show the effective trial length only.
               The strike-through "before/after" treatment lives on the
               form-side summary row so the left panel stays clean. -->
          <div class="trial-duration" if="{state.trialConfigLoaded}">
            {locale?.t('trialsignup_duration', { days: effectiveTrialDays() })}
          </div>
          <p class="trial-description" if="{state.trialConfigLoaded}">
            {locale?.t('trialsignup_description', { days: effectiveTrialDays() })}
          </p>
          
          <div class="lark-illustration">
            <img src="./ML-primary-dark.png" alt="MetaLark" class="lark-logo lg:block hidden" />
            <img src="./ML-secondary-dark-color-horizontal.png" alt="MetaLark" class="lark-logo lg:hidden block" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Right Panel: Form -->
    <div class="end-panel">
      <div class="form-container">
      <div class="brand-header">
          <h2 class="brand-title text-accent">{locale?.t('trialsignup_starttrial')}</h2>
          <!-- Trial summary — shows effective days / credits after any
               campaign override. Struck-through defaults render above
               when the code changed them so the user sees what they
               gained (or lost). -->
          <p class="font-medium trial-summary" if="{state.trialConfigLoaded}">
            <span class="trial-value-struck" if="{isDaysOverridden() || isCreditsOverridden()}">
              {locale?.t('trialsignup_trialsummary', { days: state.trialDays, credits: state.trialCredits })}
            </span>
            <span class="trial-value-override" if="{isDaysOverridden() || isCreditsOverridden()}">
              {locale?.t('trialsignup_trialsummary', { days: effectiveTrialDays(), credits: effectiveTrialCredits() })}
            </span>
            <span if="{!isDaysOverridden() && !isCreditsOverridden()}">
              {locale?.t('trialsignup_trialsummary', { days: state.trialDays, credits: state.trialCredits })}
            </span>
          </p>
      </div>

        <!-- Access Code Selection Toggle -->
        <div class="access-code-toggle" if={state.hasAccessCode === null}>
            <span class="block text-xl font-bold mb-2">{locale?.t('trialsignup_haveaccesscode')}</span>
          <p>{locale?.t('trialsignup_accesscodedescription')}</p>

          <div class="button-group">
            <button type="button" class="btn-yes" onclick={handleAccessCodeYes}>
              {locale?.t('trialsignup_yeshavecode')}
            </button>
            <button type="button" class="btn-no" onclick={handleAccessCodeNo}>
              {locale?.t('trialsignup_nostartwithoutcode')}
            </button>
          </div>
        </div>

        <!-- Signup Form (shown only when hasAccessCode is true) -->
        <div if={state.hasAccessCode === true}>
          <!-- Back button to return to toggle -->
          <button type="button" class="btn-back" onclick={handleBackToToggle}>
            {locale?.t('trialsignup_backtooptions')}
          </button>

          <form onsubmit={handleSubmit} class="signup-form">
          <!-- Contact Details Section -->
          <div class="form-section">
            <h3 class="section-label text-accent">{locale?.t('trialsignup_contactdetails')}</h3>

            <div class="form-group">
              <label for="email">{locale?.t('trialsignup_email')}</label>
              <div class="input-wrapper">
                <span class="input-icon">✉️</span>
                <input
                  type="email"
                  id="email"
                  value={state.email}
                  oninput={handleEmailInput}
                  required
                  placeholder="{locale?.t('trialsignup_emailplaceholder')}"
                  class="{state.emailError ? 'error' : ''}"
                />
              </div>
              <small class="error-text" if={state.emailError}>{state.emailError}</small>
            </div>

            <div class="form-group">
              <label for="name">{locale?.t('trialsignup_fullname')}</label>
              <div class="input-wrapper">
                <span class="input-icon">👤</span>
                <input
                  type="text"
                  id="name"
                  value={state.name}
                  oninput={handleNameInput}
                  required
                  placeholder="{locale?.t('trialsignup_fullnameplaceholder')}"
                  class="{state.nameError ? 'error' : ''}"
                />
              </div>
              <small class="error-text" if={state.nameError}>{state.nameError}</small>
            </div>

            <div class="form-group">
              <label for="company">{locale?.t('trialsignup_businessname')}</label>
              <div class="input-wrapper">
                <span class="input-icon">🏢</span>
                <input
                  type="text"
                  id="company"
                  value={state.company}
                  oninput={handleCompanyInput}
                  required
                  placeholder="{locale?.t('trialsignup_businessnameplaceholder')}"
                  class="{state.companyError ? 'error' : ''}"
                />
              </div>
              <small class="error-text" if={state.companyError}>{state.companyError}</small>
            </div>

            <div class="form-group">
              <label for="phone">{locale?.t('trialsignup_phone')}</label>
              <div class="input-wrapper">
                <span class="input-icon">📞</span>
                <input
                  type="tel"
                  id="phone"
                  value={state.phone}
                  oninput={handlePhoneInput}
                  required
                  placeholder="{locale?.t('trialsignup_phoneplaceholder')}"
                  class="{state.phoneError ? 'error' : ''}"
                />
              </div>
              <small class="error-text" if={state.phoneError}>{state.phoneError}</small>
            </div>
          </div>

          <!-- Access Code Section -->
          <div class="form-section">
            <h3 class="section-label text-accent">{locale?.t('trialsignup_accesscode')}</h3>

            <div class="form-group">
              <!-- Relative wrapper so we can position the valid-state
                   checkmark inside the right edge of the input without
                   nudging the layout. The check only renders when the
                   on-blur probe confirmed the code is valid; it doesn't
                   interfere with typing. -->
              <div class="access-code-input-wrap">
                <input
                  type="text"
                  id="accessCode"
                  value={state.accessCode}
                  oninput={handleAccessCodeInput}
                  onblur={handleAccessCodeBlur}
                  required
                  placeholder="{locale?.t('trialsignup_accesscodeplaceholder')}"
                  aria-label="{locale?.t('trialsignup_accesscode')}"
                  class="{state.accessCodeError || state.accessCodeValid === false ? 'error' : ''} {state.accessCodeValid === true ? 'valid' : ''}"
                />
                <span class="access-code-check"
                  if={state.accessCodeValid === true && !state.accessCodeChecking}
                  title="{locale?.t('trialsignup_code_valid')}"
                  aria-label="{locale?.t('trialsignup_code_valid')}">
                  <i class="icon-metalark-check"></i>
                </span>
                <span class="access-code-spinner" if={state.accessCodeChecking}>
                  <i class="icon-metalark-loader"></i>
                </span>
              </div>
              <small class="error-text" if={state.accessCodeError}>
                {state.accessCodeError}
              </small>
              <!-- `valid=false` surfaces the reason so the user knows
                   whether to retype, wait, or contact sales. Validation
                   only fires on blur so the error doesn't flash while
                   the user is still typing the code. -->
              <small class="error-text" if={state.accessCodeValid === false && !state.accessCodeChecking}>
                {accessCodeReasonText(state.accessCodeReason)}
              </small>
              <!-- Perk preview — only rendered when the campaign opted
                   in via showPreviewOnSignup. -->
              <div class="access-code-preview" if={state.accessCodeValid === true && state.accessCodePreview}>
                <div if={state.accessCodePreview.trialDurationDays}>
                  <span class="preview-label">{locale?.t('trialsignup_perk_trial_days')}</span>
                  <span class="preview-value">{state.accessCodePreview.trialDurationDays}</span>
                </div>
                <div if={state.accessCodePreview.trialCredits !== null && state.accessCodePreview.trialCredits !== undefined}>
                  <span class="preview-label">{locale?.t('trialsignup_perk_trial_credits')}</span>
                  <span class="preview-value">{state.accessCodePreview.trialCredits}</span>
                </div>
                <div if={state.accessCodePreview.discount}>
                  <span class="preview-label">{locale?.t('trialsignup_perk_discount')}</span>
                  <span class="preview-value">{state.accessCodePreview.discount}</span>
                </div>
              </div>
              <small class="hint-text font-medium">
                <span class="me-1">{locale?.t('trialsignup_noaccesscode')}</span>
                <a class="text-primary underline" href="{getStripePaymentUrl()}" target="_blank">{locale?.t('trialsignup_signupwithcard')}</a>
              </small>
            </div>
          </div>

          <!-- Billing Address Section -->
          <div class="form-section">
            <h3 class="section-label text-accent">{locale?.t('trialsignup_billingaddress')}</h3>

            <div class="form-group">
              <label for="country">{locale?.t('trialsignup_countryorregion')}</label>
              <select
                id="country"
                value={state.country}
                onchange={handleCountryInput}
                required
                class="{state.countryError ? 'error' : ''}"
              >
                <option value="">{locale?.t('trialsignup_selectcountry')}</option>
                <option value="US">United States</option>
                <option value="CA">Canada</option>
                <option value="GB">United Kingdom</option>
                <option value="AU">Australia</option>
                <option value="NZ">New Zealand</option>
                <option value="IE">Ireland</option>
                <option value="DE">Germany</option>
                <option value="FR">France</option>
                <option value="ES">Spain</option>
                <option value="IT">Italy</option>
                <option value="NL">Netherlands</option>
                <option value="BE">Belgium</option>
                <option value="CH">Switzerland</option>
                <option value="AT">Austria</option>
                <option value="SE">Sweden</option>
                <option value="NO">Norway</option>
                <option value="DK">Denmark</option>
                <option value="FI">Finland</option>
                <option value="PL">Poland</option>
                <option value="CZ">Czech Republic</option>
                <option value="PT">Portugal</option>
                <option value="GR">Greece</option>
                <option value="JP">Japan</option>
                <option value="KR">South Korea</option>
                <option value="SG">Singapore</option>
                <option value="HK">Hong Kong</option>
                <option value="IN">India</option>
                <option value="MX">Mexico</option>
                <option value="BR">Brazil</option>
                <option value="AR">Argentina</option>
                <option value="CL">Chile</option>
                <option value="CO">Colombia</option>
                <option value="ZA">South Africa</option>
                <option value="IL">Israel</option>
                <option value="AE">United Arab Emirates</option>
                <option value="SA">Saudi Arabia</option>
              </select>
              <small class="error-text" if={state.countryError}>{state.countryError}</small>
            </div>

            <div class="form-group">
              <input
                type="text"
                id="addressLine1"
                value={state.addressLine1}
                oninput={handleAddressLine1Input}
                required
                placeholder="{locale?.t('trialsignup_address')}"
                aria-label="{locale?.t('trialsignup_address')}"
                class="{state.addressLine1Error ? 'error' : ''}"
              />
              <small class="error-text" if={state.addressLine1Error}>{state.addressLine1Error}</small>
            </div>

            <div class="form-group">
              <input
                type="text"
                id="addressLine2"
                value={state.addressLine2}
                oninput={handleAddressLine2Input}
                placeholder="{locale?.t('trialsignup_addressline2')}"
                aria-label="{locale?.t('trialsignup_addressline2')}"
              />
            </div>

            <div class="form-row">
              <div class="form-group form-group-half">
                <input
                  type="text"
                  id="city"
                  value={state.city}
                  oninput={handleCityInput}
                  required
                  placeholder="{locale?.t('trialsignup_city')}"
                  aria-label="{locale?.t('trialsignup_city')}"
                  class="{state.cityError ? 'error' : ''}"
                />
                <small class="error-text" if={state.cityError}>{state.cityError}</small>
              </div>

              <div class="form-group form-group-quarter">
                <select
                  if={state.showStateDropdown}
                  id="state"
                  value={state.stateProvince}
                  onchange={handleStateInput}
                  required
                  aria-label="{locale?.t('trialsignup_state')}"
                  class="{state.stateError ? 'error' : ''}"
                >
                  <option value="">{locale?.t('trialsignup_select')}</option>
                  <option each={option in state.stateOptions} value={option.value}>
                    {option.label}
                  </option>
                </select>
                <input
                  if={!state.showStateDropdown}
                  type="text"
                  id="state"
                  value={state.stateProvince}
                  oninput={handleStateInput}
                  required={state.stateRequired}
                  placeholder={state.statePlaceholder}
                  aria-label="{locale?.t('trialsignup_state')}"
                  class="{state.stateError ? 'error' : ''}"
                />
                <small class="error-text" if={state.stateError}>{state.stateError}</small>
              </div>

              <div class="form-group form-group-quarter">
                <input
                  type="text"
                  id="postalCode"
                  value={state.postalCode}
                  oninput={handlePostalCodeInput}
                  required
                  placeholder="{locale?.t('trialsignup_zip')}"
                  aria-label="{locale?.t('trialsignup_zip')}"
                  class="{state.postalCodeError ? 'error' : ''}"
                />
                <small class="error-text" if={state.postalCodeError}>{state.postalCodeError}</small>
              </div>
            </div>
          </div>

          <!-- Error Message -->
          <div if={state.error} class="error-alert">
            <span class="error-icon">⚠</span>
            {state.error}
          </div>

          <!-- Submit Button -->
          <button
            type="submit"
            class="btn-submit"
            disabled={state.loading}
          >
            {state.loading ? locale?.t('trialsignup_creatingtrial') : locale?.t('trialsignup_startfreetrial')}
          </button>
        </form>
        </div>
        <!-- End of conditional form wrapper -->

        <div class="footer-note">
          <p class="">
            {locale?.t('trialsignup_alreadyhaveaccount')} <a href="#/login" class="text-primary underline ms-1">{locale?.t('trialsignup_signin')}</a>
          </p>
          <!-- Language Selector -->
          <div class="text-center mt-6 flex justify-center">
            <div class="w-64">
              <language-selector class="flex flex-row"></language-selector>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <style>
    * {
      box-sizing: border-box;
    }

    .split-container {
      display: flex;
      min-height: 100vh;
      background: white;
    }

    /* Start Panel - Branding */
    .start-panel {
      flex: 0 0 480px;
      color: white;
      padding: 48px 40px;
      display: flex;
      flex-direction: column;
      border-start-start-radius: 15px;
      border-end-start-radius: 15px;
    }

    .brand-section {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .logo-badge {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 40px;
    }

    /*.company-logo {*/
    /*  height: 96px;*/
    /*  width: auto;*/
    /*}*/

    .trial-info {
      margin-bottom: 40px;
    }

    .trial-title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 16px;
      opacity: 0.9;
    }

    .trial-duration {
      font-size: 48px;
      font-weight: 700;
      margin-bottom: 24px;
      line-height: 1;
    }

    .trial-description {
      font-size: 16px;
      line-height: 1.6;
      opacity: 0.9;
      margin: 0;
    }

    .lark-illustration {
      text-align: center;
      margin-top: 48px;
    }

    /*.lark-logo {*/
    /*  height: 320px;*/
    /*  width: auto;*/
    /*}*/

    /* Right Panel - Form */
    .end-panel {
      flex: 1;
      overflow-y: auto;
    }

    .form-container {
      max-width: 600px;
      margin: 0 auto;
      padding: 48px 40px;
      background: white;
      min-height: 100%;
    }

    .form-title {
      font-size: 24px;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0 0 32px 0;
    }

    .form-section {
      margin-bottom: 32px;
    }

    .section-label {
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 16px 0;
    }

    .form-group {
      margin-bottom: 16px;
    }

    .form-row {
      display: flex;
      gap: 12px;
    }

    .form-group-half {
      flex: 1;
    }

    .form-group-quarter {
      flex: 0 0 calc(25% - 6px);
    }

    label {
      display: block;
      color: #4a4a4a;
      font-weight: 500;
      margin-bottom: 6px;
      font-size: 13px;
      text-transform: capitalize;
    }

    .optional {
      color: #6b7280;
      font-weight: 400;
      text-transform: none;
    }

    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }

    .input-icon {
      position: absolute;
      inset-inline-start: 14px;
      font-size: 16px;
      opacity: 0.5;
      pointer-events: none;
    }

    .input-wrapper input {
      padding-inline-start: 44px !important;
    }

    .form-group input[type="email"],
    .form-group input[type="text"],
    .form-group input[type="tel"],
    .form-group select {
      width: 100%;
      padding: 12px 14px;
      border: 1px solid #d6d6d6;
      border-radius: 6px;
      font-size: 15px;
      background: white;
      transition: border-color 0.15s, box-shadow 0.15s;
    }

    .form-group input:focus,
    .form-group select:focus {
      outline: none;
      border-color: #6b7ba8;
      box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.1);
    }

    .form-group input.error,
    .form-group select.error {
      border-color: #df1b41;
    }

    .form-group input.error:focus,
    .form-group select.error:focus {
      box-shadow: 0 0 0 3px rgba(223, 27, 65, 0.1);
    }

    .form-group select {
      cursor: pointer;
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%234a4a4a' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 14px center;
      padding-right: 40px;
    }

    .error-text {
      display: block;
      color: #df1b41;
      font-size: 12px;
      margin-top: 4px;
    }

    .hint-text {
      display: block;
      color: #6b7280;
      font-size: 13px;
      margin-top: 6px;
    }

    .hint-text a {
      font-weight: 500;
    }

    .hint-text a:hover {
      text-decoration: underline;
    }

    /* Access-code input wrapper — relative so the valid-state check
       and loading spinner can live inside the right edge of the field
       without shifting the layout. */
    .access-code-input-wrap {
      position: relative;
    }

    .access-code-input-wrap input {
      padding-right: 36px; /* reserve space for the check / spinner */
    }

    .access-code-input-wrap input.valid {
      border-color: rgba(10, 125, 61, 0.55);
      background: rgba(10, 125, 61, 0.04);
    }

    .access-code-check {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #0a7d3d;
      font-size: 18px;
      line-height: 1;
      pointer-events: none;
    }

    .access-code-spinner {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #6b7280;
      font-size: 18px;
      line-height: 1;
      pointer-events: none;
      animation: ac-spin 0.9s linear infinite;
    }

    @keyframes ac-spin {
      from { transform: translateY(-50%) rotate(0deg); }
      to   { transform: translateY(-50%) rotate(360deg); }
    }

    /* Access-code perk preview — only renders when the campaign opted
       in via showPreviewOnSignup AND the resolve call returned a preview
       block. Designed to be eye-catching but not larger than the form
       itself: a tinted card with one line per perk. */
    .access-code-preview {
      margin-top: 8px;
      padding: 10px 12px;
      border: 1px solid rgba(10, 125, 61, 0.35);
      background: rgba(10, 125, 61, 0.08);
      border-radius: 6px;
      font-size: 13px;
      color: #0a7d3d;
    }

    .access-code-preview .preview-label {
      color: #374151;
      margin-right: 6px;
    }

    .access-code-preview .preview-value {
      font-weight: 600;
      color: #0a7d3d;
    }

    /* Struck / override pair for trial length + credits on the form's
       summary line. The default values render in muted-with-strikethrough
       so the user can see the starting point, and the override renders
       in brand green so the improvement stands out. */
    .trial-value-struck {
      text-decoration: line-through;
      opacity: 0.65;
      margin-right: 6px;
    }

    .trial-value-override {
      font-weight: 700;
      color: #0a7d3d;
    }

    .brand-header {
      text-align: center;
      margin-bottom: 32px;
      padding-bottom: 24px;
      border-bottom: 1px solid #e5e7eb;
    }
    .brand-title {
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    /* Access Code Toggle Styles */
    .access-code-toggle {
      text-align: center;
      padding: 40px 20px;
      max-width: 600px;
      margin: 0 auto;
    }

    .access-code-toggle h3 {
      font-size: 28px;
      margin-bottom: 16px;
      color: #1a1a1a;
    }

    .access-code-toggle p {
      font-size: 16px;
      color: #666;
      margin-bottom: 32px;
      line-height: 1.5;
    }

    .access-code-toggle .button-group {
      display: flex;
      gap: 16px;
      justify-content: center;
      flex-wrap: wrap;
    }

    .access-code-toggle button {
      min-width: 200px;
      padding: 16px 32px;
      font-size: 16px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-weight: 600;
    }

    .access-code-toggle .btn-yes {
      background-color: var(--color-primary);
      color: white;
      border: none;
    }

    .access-code-toggle .btn-yes:hover {
      background-color: #6b7ba8;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(139, 149, 187, 0.3);
    }

    .access-code-toggle .btn-no {
      background-color: white;
      color: var(--color-primary);
      border: 2px solid var(--color-primary);
    }

    .access-code-toggle .btn-no:hover {
      background-color: #f0f7ff;
      transform: translateY(-2px);
    }

    /* Back Button Styles */
    .btn-back {
      background: transparent;
      border: none;
      color: var(--color-primary);
      font-size: 14px;
      font-weight: 500;
      padding: 8px 0;
      margin-bottom: 24px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      transition: color 0.2s ease;
    }

    .btn-back:hover {
      color: #3f4e7c;
      text-decoration: underline;
    }

    .error-alert {
      background: #fff5f5;
      border: 1px solid #fed7d7;
      color: #c53030;
      padding: 12px 16px;
      border-radius: 6px;
      margin-bottom: 16px;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .error-icon {
      font-size: 18px;
    }

    .btn-submit {
      width: 100%;
      padding: 14px 24px;
      background: var(--color-primary);
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: background-color 0.2s, transform 0.1s;
      margin-top: 24px;
    }

    .btn-submit:hover:not(:disabled) {
      background: #6b7ba8;
      transform: translateY(-1px);
    }

    .btn-submit:disabled {
      background: #cbd5e0;
      cursor: not-allowed;
      transform: none;
    }

    .footer-note {
      text-align: center;
      margin-top: 24px;
      padding-top: 24px;
      border-top: 1px solid #e5e7eb;
    }

    .footer-note p {
      color: #6b7280;
      font-size: 14px;
      margin: 0;
    }

    .footer-note a {
      font-weight: 500;
    }

    .footer-note a:hover {
      text-decoration: underline;
    }

    /* Responsive Design */
    @media (max-width: 1024px) {
      .split-container {
        flex-direction: column;
      }

      .start-panel {
        flex: 0 0 auto;
        min-height: 400px;
        border-radius: 15px;
      }

      /*.lark-illustration {*/
      /*  display: none;*/
      /*}*/
    }

    @media (max-width: 768px) {
      .start-panel {
        padding: 32px 24px;
        min-height: 300px;
        border-radius: 15px;
      }

      .trial-duration {
        font-size: 36px;
      }

      .trial-info {
          margin-bottom: 0;
      }

      .form-container {
        padding: 0;
        margin-top: 30px
      }

      .form-row {
        flex-direction: column;
      }

      .form-group-half,
      .form-group-quarter {
        flex: 1;
        width: 100%;
      }
    }
  </style>

  <script>
    import { getApi, getCampaignService } from '../services/service-loader'
    import languageSelector from '../components/language-selector.tag';

    const STRIPE_PAYMENT_BASE = 'https://buy.stripe.com/cNi4gzffJgKabmu4fz6g803';

    export default {
      components: {
        languageSelector
      },

      getStripePaymentUrl() {
        const lang = this.locale?.getLanguageCode() || 'en';
        return `${STRIPE_PAYMENT_BASE}?locale=${lang}`;
      },

      state: {
        hasAccessCode: null, // null = not selected, true = yes, false = no
        email: '',
        name: '',
        company: '',
        phone: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateProvince: '',
        postalCode: '',
        country: '',
        showStateDropdown: false,
        stateOptions: [],
        stateRequired: true,
        statePlaceholder: '',
        accessCode: '',
        // Live /campaigns/resolve state — populated by validateAccessCode.
        // `valid` is null until the first response. `preview` is only
        // present when the campaign opted into showPreviewOnSignup.
        accessCodeChecking: false,
        accessCodeValid: null,            // true | false | null
        accessCodeReason: null,            // UNKNOWN_CODE, EXPIRED, ...
        accessCodePreview: null,           // { trialDurationDays, trialCredits } or { discount }
        loading: false,
        error: '',
        emailError: '',
        nameError: '',
        companyError: '',
        phoneError: '',
        addressLine1Error: '',
        cityError: '',
        stateError: '',
        postalCodeError: '',
        countryError: '',
        accessCodeError: '',
        trialConfigLoaded: false,
        trialDays: 0,
        trialCredits: 0
      },

      // Access code toggle handlers
      handleAccessCodeYes(e) {
        e.preventDefault();
        this.update({ hasAccessCode: true });
      },

      handleAccessCodeNo(e) {
        e.preventDefault();
        // Redirect to existing Stripe Payment Link
        window.location.href = this.getStripePaymentUrl();
      },

      handleBackToToggle(e) {
        e.preventDefault();
        this.update({ hasAccessCode: null });
      },

      async onMounted() {
        if (this.locale) {
          this.state.statePlaceholder = this.locale.t('trialsignup_state_placeholder_default');
        }
        const hash = window.location.hash
        const queryStringIndex = hash.indexOf('?')
        if (queryStringIndex !== -1) {
          const queryString = hash.substring(queryStringIndex + 1)
          const params = new URLSearchParams(queryString)
          const accessCode = params.get('code') || params.get('accessCode')
          if (accessCode) {
            // If access code is in URL, skip the toggle and show form directly
            this.update({
              accessCode,
              hasAccessCode: true
            })
            // Validate the prefilled code so the "show perks" preview
            // renders immediately for marketing deep-links that arrive
            // with ?code=... in the URL. Small delay lets the initial
            // render settle before the fetch.
            setTimeout(() => this.validateAccessCode(accessCode, this.state.email), 50);
          }
        }

        // Fetch current trial configuration
        try {
          const api = await getApi()
          const response = await api.get('/trial/config')
          if (response.data) {
            this.update({
              trialConfigLoaded: true,
              trialDays: response.data.durationDays,
              trialCredits: response.data.credits
            })
          }
        } catch (error) {
          console.error('Failed to load trial config:', error)
          // Continue with default values
        }
      },

      handleEmailInput(e) {
        this.update({
          email: e.target.value,
          error: '',
          emailError: ''
        })
      },

      handleNameInput(e) {
        this.update({
          name: e.target.value,
          error: '',
          nameError: ''
        })
      },

      handleCompanyInput(e) {
        this.update({
          company: e.target.value,
          error: '',
          companyError: ''
        })
      },

      handlePhoneInput(e) {
        this.update({
          phone: e.target.value,
          error: '',
          phoneError: ''
        })
      },

      handleAddressLine1Input(e) {
        this.update({
          addressLine1: e.target.value,
          error: '',
          addressLine1Error: ''
        })
      },

      handleAddressLine2Input(e) {
        this.update({ addressLine2: e.target.value })
      },

      handleCityInput(e) {
        this.update({
          city: e.target.value,
          error: '',
          cityError: ''
        })
      },

      handleStateInput(e) {
        this.update({
          stateProvince: e.target.value,
          error: '',
          stateError: ''
        })
      },

      getStateOptions(country) {
        const US_STATES = [
          { value: 'AL', label: 'Alabama' },
          { value: 'AK', label: 'Alaska' },
          { value: 'AZ', label: 'Arizona' },
          { value: 'AR', label: 'Arkansas' },
          { value: 'CA', label: 'California' },
          { value: 'CO', label: 'Colorado' },
          { value: 'CT', label: 'Connecticut' },
          { value: 'DE', label: 'Delaware' },
          { value: 'FL', label: 'Florida' },
          { value: 'GA', label: 'Georgia' },
          { value: 'HI', label: 'Hawaii' },
          { value: 'ID', label: 'Idaho' },
          { value: 'IL', label: 'Illinois' },
          { value: 'IN', label: 'Indiana' },
          { value: 'IA', label: 'Iowa' },
          { value: 'KS', label: 'Kansas' },
          { value: 'KY', label: 'Kentucky' },
          { value: 'LA', label: 'Louisiana' },
          { value: 'ME', label: 'Maine' },
          { value: 'MD', label: 'Maryland' },
          { value: 'MA', label: 'Massachusetts' },
          { value: 'MI', label: 'Michigan' },
          { value: 'MN', label: 'Minnesota' },
          { value: 'MS', label: 'Mississippi' },
          { value: 'MO', label: 'Missouri' },
          { value: 'MT', label: 'Montana' },
          { value: 'NE', label: 'Nebraska' },
          { value: 'NV', label: 'Nevada' },
          { value: 'NH', label: 'New Hampshire' },
          { value: 'NJ', label: 'New Jersey' },
          { value: 'NM', label: 'New Mexico' },
          { value: 'NY', label: 'New York' },
          { value: 'NC', label: 'North Carolina' },
          { value: 'ND', label: 'North Dakota' },
          { value: 'OH', label: 'Ohio' },
          { value: 'OK', label: 'Oklahoma' },
          { value: 'OR', label: 'Oregon' },
          { value: 'PA', label: 'Pennsylvania' },
          { value: 'RI', label: 'Rhode Island' },
          { value: 'SC', label: 'South Carolina' },
          { value: 'SD', label: 'South Dakota' },
          { value: 'TN', label: 'Tennessee' },
          { value: 'TX', label: 'Texas' },
          { value: 'UT', label: 'Utah' },
          { value: 'VT', label: 'Vermont' },
          { value: 'VA', label: 'Virginia' },
          { value: 'WA', label: 'Washington' },
          { value: 'WV', label: 'West Virginia' },
          { value: 'WI', label: 'Wisconsin' },
          { value: 'WY', label: 'Wyoming' },
          { value: 'DC', label: 'District of Columbia' }
        ];

        const CANADIAN_PROVINCES = [
          { value: 'AB', label: 'Alberta' },
          { value: 'BC', label: 'British Columbia' },
          { value: 'MB', label: 'Manitoba' },
          { value: 'NB', label: 'New Brunswick' },
          { value: 'NL', label: 'Newfoundland and Labrador' },
          { value: 'NS', label: 'Nova Scotia' },
          { value: 'ON', label: 'Ontario' },
          { value: 'PE', label: 'Prince Edward Island' },
          { value: 'QC', label: 'Quebec' },
          { value: 'SK', label: 'Saskatchewan' },
          { value: 'NT', label: 'Northwest Territories' },
          { value: 'NU', label: 'Nunavut' },
          { value: 'YT', label: 'Yukon' }
        ];

        if (country === 'US') {
          return US_STATES;
        } else if (country === 'CA') {
          return CANADIAN_PROVINCES;
        }
        return [];
      },

      handlePostalCodeInput(e) {
        this.update({
          postalCode: e.target.value,
          error: '',
          postalCodeError: ''
        })
      },

      getStateFieldConfig(country) {
        const configs = {
          'US': { placeholder: this.locale.t('trialsignup_state_placeholder_state'), required: true, showDropdown: true },
          'CA': { placeholder: this.locale.t('trialsignup_state_placeholder_province'), required: true, showDropdown: true },
          'AU': { placeholder: this.locale.t('trialsignup_state_placeholder_state'), required: true, showDropdown: false },
          'MX': { placeholder: this.locale.t('trialsignup_state_placeholder_state'), required: true, showDropdown: false },
          'BR': { placeholder: this.locale.t('trialsignup_state_placeholder_state'), required: true, showDropdown: false },
          'IN': { placeholder: this.locale.t('trialsignup_state_placeholder_state'), required: true, showDropdown: false },
          'DE': { placeholder: this.locale.t('trialsignup_state_placeholder_state_optional'), required: false, showDropdown: false },
          'IT': { placeholder: this.locale.t('trialsignup_state_placeholder_region_optional'), required: false, showDropdown: false },
          'ES': { placeholder: this.locale.t('trialsignup_state_placeholder_region_optional'), required: false, showDropdown: false },
          'FR': { placeholder: this.locale.t('trialsignup_state_placeholder_region_optional'), required: false, showDropdown: false },
          'GB': { placeholder: this.locale.t('trialsignup_state_placeholder_county_optional'), required: false, showDropdown: false },
          'IE': { placeholder: this.locale.t('trialsignup_state_placeholder_county_optional'), required: false, showDropdown: false },
          'JP': { placeholder: this.locale.t('trialsignup_state_placeholder_prefecture_optional'), required: false, showDropdown: false },
          'CN': { placeholder: this.locale.t('trialsignup_state_placeholder_province_optional'), required: false, showDropdown: false },
          'CH': { placeholder: this.locale.t('trialsignup_state_placeholder_canton_optional'), required: false, showDropdown: false },
          'NL': { placeholder: this.locale.t('trialsignup_state_placeholder_province_optional'), required: false, showDropdown: false },
          'BE': { placeholder: this.locale.t('trialsignup_state_placeholder_province_optional'), required: false, showDropdown: false }
        };

        return configs[country] || {
          placeholder: this.locale.t('trialsignup_state_placeholder_default'),
          required: false,
          showDropdown: false
        };
      },

      handleCountryInput(e) {
        const selectedCountry = e.target.value;
        const config = this.getStateFieldConfig(selectedCountry);
        const stateOptions = config.showDropdown ? this.getStateOptions(selectedCountry) : [];
        
        this.update({
          country: selectedCountry,
          showStateDropdown: config.showDropdown,
          stateOptions: stateOptions,
          stateRequired: config.required,
          statePlaceholder: config.placeholder,
          stateProvince: '', // Clear state when country changes
          error: '',
          countryError: ''
        })
      },

      handleAccessCodeInput(e) {
        // Sync state and wipe any prior validation result — we don't want
        // a stale green check to linger while the user is retyping. The
        // actual resolve() call only fires on blur (see
        // handleAccessCodeBlur) so the user isn't interrupted mid-type
        // and the unauth endpoint isn't a free code-guessing oracle.
        this.update({
          accessCode: e.target.value,
          error: '',
          accessCodeError: '',
          accessCodeValid: null,
          accessCodeReason: null,
          accessCodePreview: null,
        });
      },

      handleAccessCodeBlur(e) {
        const code = (e.target.value || '').trim();
        if (!code) return;
        // Skip re-validation if nothing changed since the last success —
        // e.g. blurring the field after tab-focus shouldn't cost a
        // round-trip when we already know the code is valid.
        if (this.state.accessCodeValid !== null && code === this._lastValidatedCode) return;
        this._lastValidatedCode = code;
        this.validateAccessCode(code, this.state.email);
      },

      // Effective trial length / credits for this signup — the preview
      // block may carry overrides from the resolved campaign. Both
      // helpers fall back to the platform defaults loaded from
      // /trial/config so they're safe to render before the user touches
      // the access-code field.
      effectiveTrialDays() {
        const p = this.state.accessCodePreview;
        if (p && typeof p.trialDurationDays === 'number' && p.trialDurationDays > 0) {
          return p.trialDurationDays;
        }
        return this.state.trialDays;
      },

      effectiveTrialCredits() {
        const p = this.state.accessCodePreview;
        if (p && typeof p.trialCredits === 'number' && p.trialCredits >= 0) {
          return p.trialCredits;
        }
        return this.state.trialCredits;
      },

      isDaysOverridden() {
        const p = this.state.accessCodePreview;
        return !!(p && typeof p.trialDurationDays === 'number'
          && p.trialDurationDays > 0
          && p.trialDurationDays !== this.state.trialDays);
      },

      isCreditsOverridden() {
        const p = this.state.accessCodePreview;
        return !!(p && typeof p.trialCredits === 'number'
          && p.trialCredits >= 0
          && p.trialCredits !== this.state.trialCredits);
      },

      // Map the resolve endpoint's reason enum to a user-facing phrase.
      // Falls back to a generic "not valid" message for unknowns so a new
      // backend reason code never leaks a raw token to the signup form.
      accessCodeReasonText(reason) {
        const t = this.locale?.t?.bind(this.locale);
        const key = `trialsignup_code_reason_${(reason || 'unknown').toLowerCase()}`;
        const phrase = t ? t(key) : null;
        if (phrase && phrase !== key) return phrase;
        return t ? t('trialsignup_code_reason_unknown') : 'Code is not valid.';
      },

      // Live /campaigns/resolve — runs on every debounced keystroke when
      // the access-code input has content. Failures never block the form
      // client-side (submit still validates server-side), but we do
      // render the reason inline so the user can fix it before hitting
      // "Create Account". The preview block is only rendered when the
      // server returns one (opt-in per campaign via showPreviewOnSignup).
      async validateAccessCode(code, email) {
        this.update({ accessCodeChecking: true });
        try {
          const svc = await getCampaignService();
          const result = await svc.resolve(code, email);
          // Ignore stale responses — if the user kept typing, only the
          // latest code should determine the UI state.
          if (this.state.accessCode.trim() !== code) return;
          this.update({
            accessCodeChecking: false,
            accessCodeValid: !!result?.valid,
            accessCodeReason: result?.reason || null,
            accessCodePreview: result?.preview || null,
          });
        } catch (err) {
          // Ignore network failures silently — submit validates too.
          console.warn('Campaign resolve probe failed:', err);
          this.update({ accessCodeChecking: false });
        }
      },

      handleManualAddress(e) {
        e.preventDefault()
        // Placeholder for manual address entry functionality
        console.log('Manual address entry clicked')
      },

      async handleSubmit(e) {
        e.preventDefault()

        // Clear all errors
        this.update({
          error: '',
          emailError: '',
          nameError: '',
          companyError: '',
          phoneError: '',
          addressLine1Error: '',
          cityError: '',
          stateError: '',
          postalCodeError: '',
          countryError: '',
          accessCodeError: '',
          loading: true
        })

        // Client-side validation
        let hasError = false;

        if (!this.state.email || !this.state.email.includes('@')) {
          this.update({ emailError: this.locale.t('trialsignup_error_validemail') })
          hasError = true
        }

        if (!this.state.name || this.state.name.trim().length < 2) {
          this.update({ nameError: this.locale.t('trialsignup_error_fullname') })
          hasError = true
        }

        if (!this.state.company || this.state.company.trim().length < 2) {
          this.update({ companyError: this.locale.t('trialsignup_error_companyname') })
          hasError = true
        }

        if (!this.state.phone || this.state.phone.trim().length < 10) {
          this.update({ phoneError: this.locale.t('trialsignup_error_validphone') })
          hasError = true
        }

        if (!this.state.addressLine1 || this.state.addressLine1.trim().length < 3) {
          this.update({ addressLine1Error: this.locale.t('trialsignup_error_streetaddress') })
          hasError = true
        }

        if (!this.state.city || this.state.city.trim().length < 2) {
          this.update({ cityError: this.locale.t('trialsignup_error_city') })
          hasError = true
        }

        if (this.state.stateRequired && (!this.state.stateProvince || this.state.stateProvince.trim().length < 2)) {
          this.update({ stateError: this.locale.t('trialsignup_error_state', { field: this.state.statePlaceholder }) })
          hasError = true
        }

        if (!this.state.postalCode || this.state.postalCode.trim().length < 3) {
          this.update({ postalCodeError: this.locale.t('trialsignup_error_postalcode') })
          hasError = true
        }

        if (!this.state.country) {
          this.update({ countryError: this.locale.t('trialsignup_error_selectcountry') })
          hasError = true
        }

        if (!this.state.accessCode || this.state.accessCode.trim().length === 0) {
          this.update({ accessCodeError: this.locale.t('trialsignup_error_accesscode') })
          hasError = true
        }

        if (hasError) {
          this.update({ loading: false })
          return
        }

        try {
          const api = await getApi()
          const response = await api.post('/trial/signup', {
            email: this.state.email.trim(),
            name: this.state.name.trim(),
            company: this.state.company.trim(),
            phone: this.state.phone.trim(),
            address: {
              line1: this.state.addressLine1.trim(),
              line2: this.state.addressLine2.trim() || undefined,
              city: this.state.city.trim(),
              state: this.state.stateProvince.trim(),
              postalCode: this.state.postalCode.trim(),
              country: this.state.country
            },
            accessCode: this.state.accessCode.trim()
          })

          if (response.data.success) {
            // Redirect to success page
            window.location.hash = '#/trial-success?email=' + encodeURIComponent(this.state.email)
          } else {
            this.update({
              loading: false,
              error: response.data.message || this.locale.t('trialsignup_error_signupfailed')
            })
          }
        } catch (error) {
          console.error('Signup error:', error)

          const errorMessage = error.response?.data?.message || error.message || this.locale.t('trialsignup_error_signupfailed')
          
          // Check if it's an access code error
          if (errorMessage.toLowerCase().includes('access code') || 
              errorMessage.toLowerCase().includes('invalid code')) {
            this.update({
              loading: false,
              accessCodeError: errorMessage
            })
          } else if (errorMessage.toLowerCase().includes('email')) {
            this.update({
              loading: false,
              emailError: errorMessage
            })
          } else {
            this.update({
              loading: false,
              error: errorMessage
            })
          }
        }
      }
    }
  </script>
</trial-signup-page>